/**
 * Created by zhengyf on 2018/3/13.
 */

;(function () {

    LogisticsQueryCtrl.$inject = ['request', '$timeout'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .controller('LogisticsQueryCtrl', LogisticsQueryCtrl);

    function LogisticsQueryCtrl(request, $timeout) {

        var vm = this;
        var util = DSSX.util;

        var store = {
            seaLclDestPort: [{
                "label": "BARCELONA (SPAIN)",
                "value": "ESBCN"
            }, {
                "label": "CHICAGO, IL (THE UNITED STATES OF AMERICA)",
                "value": "USCHI"
            }, {"label": "FELIXSTOWE (UNITED KINGDOM)", "value": "GBFXT"}, {
                "label": "GENOA (ITALY)",
                "value": "ITGOA"
            }, {
                "label": "HAMBURG (GERMANY)",
                "value": "DEHAM"
            }, {
                "label": "LONG BEACH, CA (THE UNITED STATES OF AMERICA)",
                "value": "USLGB"
            }, {
                "label": "LOS ANGELES, CA (THE UNITED STATES OF AMERICA)",
                "value": "USLAX"
            }, {"label": "MIAMI, FL (THE UNITED STATES OF AMERICA)", "value": "USMIA"}, {
                "label": "MONTREAL (CANADA)",
                "value": "CAMTR"
            }, {
                "label": "NEW YORK, NY (THE UNITED STATES OF AMERICA)",
                "value": "USNYC"
            }, {
                "label": "OAKLAND, CA (THE UNITED STATES OF AMERICA)",
                "value": "USOAK"
            }, {
                "label": "ROTTERDAM (NETHERLANDS)",
                "value": "NLRTM"
            }, {
                "label": "SEATTLE, WA (THE UNITED STATES OF AMERICA)",
                "value": "USSEA"
            }, {"label": "SYDNEY (AUSTRALIA)", "value": "AUSYD"}, {
                "label": "TORONTO (CANADA)",
                "value": "CATOR"
            }, {"label": "VANCOUVER (CANADA)", "value": "CAVAN"}],
            expressQuery: [
                {
                    title: '门到门',
                    subTitle: '免报关费',
                    list: [],
                    search: false
                },
                {
                    title: '仓到门',
                    list: [],
                    search: false
                }
            ],
            normalQuery: [
                {
                    list: [],
                    search: false
                }
            ],
            listKey: [
                'expressDest',
                'airOriginPort',
                'airDestPort',
                'airDestPort',
                'seaLclOriginPort',
                'seaLclDestPort',
                'seaFlcOriginPort',
                'seaFlcDestPort',
                'echeOriginPort',
                'echeDestPort',
                'landTrailerOriginPort',
                'landTrailerDestPort',
                'landRailDestPort',
                'landRailDestStore',
                'landRailOriginPort',
                'seaFlcDestAddr',
                'seaLclPickUpAddr',
                'seaLclDoorAddr'
            ]
        };
        var oldOriginPortId;

        vm.c = {
            leftMenu: [
                {
                    title: '一达通外贸综合服务',
                    href: '',
                    strong: true
                },
                {
                    title: '通关\\外汇\\退税',
                    href: ''
                },
                {
                    title: '物流服务',
                    href: '',
                    strong: true
                },
                {
                    title: '查询报价并安排发货',
                    href: '',
                    current: true
                },
                {
                    title: '管理物流订单',
                    href: ''
                },
                {
                    title: '我收到的委托单',
                    href: ''
                },
                {
                    title: '我的优惠卷',
                    href: ''
                },
                {
                    title: '金融服务',
                    href: '',
                    strong: true
                },
                {
                    title: '金融管家',
                    href: ''
                },
                {
                    title: '信用证管理',
                    href: ''
                }
            ],
            transportWay: [
                {
                    name: '海运',
                    en: 'sea',
                    source: 'ma',
                    icon: true
                },
                {
                    name: '空运',
                    en: 'air',
                    source: 'ma',
                    serviceType: 'air_ptp',
                    icon: false
                },
                {
                    name: '快递',
                    en: 'express',
                    source: '', // 快递请求另外的接口
                    serviceType: 'express',
                    icon: false
                },
                {
                    name: '陆运(中港、拖车、铁路)',
                    en: 'eche',
                    source: 'ma',
                    icon: true
                }
            ],
            seaNav: [
                {
                    name: '海运拼箱',
                    en: '',
                    type: 'sea',
                    source: 'ma',
                    serviceType: 'lcl',
                },
                {
                    name: '海运整柜',
                    en: 'hyzg',
                    type: 'sea',
                    source: 'ma',
                    serviceType: 'eshipping',
                },
            ],
            echeNav: [
                {
                    name: '中港陆运',
                    en: '',
                    type: 'eche',
                    source: 'ma',
                    serviceType: 'eche',
                },
                {
                    name: '集港拖车',
                    en: '',
                    type: 'eche',
                    source: 'ma',
                    serviceType: 'land_trailer',
                },
                {
                    name: '国际铁路',
                    en: '',
                    type: 'eche',
                    source: 'ma',
                    serviceType: 'land_rail',
                },

            ],
            curTabNavType: '', // sea 海运 eche 陆运
            curWay: {
                name: '',
                en: '',
                serviceType: ''
            },
            expressDest: { // 快递的目的地列表
                show: false,
                list: [],
                curList: [],
                loading: false,
                selected: {}
            },
            airOriginPort: {
                show: false,
                list: [],
                curList: [],
                loading: false,
                selected: {}
            },
            airDestPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            seaLclOriginPort: {
                show: false,
                list: [],
                curList: [],
                loading: false,
                selected: {}
            },
            seaLclDestPort: {
                show: false,
                list: store.seaLclDestPort,
                loading: false,
                selected: {}
            },
            seaFlcOriginPort: {
                show: false,
                list: [],
                curList: [],
                loading: false,
                selected: {}
            },
            seaFlcDestPort: {
                show: false,
                list: store.seaLclDestPort,
                loading: false,
                selected: {}
            },
            echeOriginPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            echeDestPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            landTrailerOriginPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            landTrailerDestPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            landRailDestPort: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            landRailDestStore: {
                show: false,
                list: [],
                loading: false,
                selected: {}
            },
            landRailOriginPort: {
                show: false,
                list: [],
                loading: false,
                selected: {}
            },
            seaFlcDestAddr: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            seaLclPickUpAddr: {
                show: false,
                list: [],
                loading: false,
                selected: [],
                tabs: [
                    {
                        name: '请选择'
                    }
                ],
                completeInfo: {
                    label: '',
                    value: ''
                }
            },
            seaLclDoorAddr: {
                show: false,
                list: [],
                curList: [],
                loading: false,
                selected: {}
            },
        };

        vm.d = {
            queryWayInfo: {
                express: { // 快递
                    originZip: {
                        zip: '',
                        zipErr: false
                    },
                    goodsInfo: {
                        showDialog: false,
                        goods: [getBasicGoodsInfo()],
                        total: '',
                        detail: {
                            volume: '',
                            weight: ''
                        },
                        goodsInfoErr: false
                    },
                    destination: {
                        dest: '',
                        destErr: false
                    }
                },
                air: {
                    originPort: {
                        port: '',
                        portErr: false
                    },
                    destPort: {
                        country: '',
                        city: '',
                        portErr: false
                    },
                    volume: {
                        v: '',
                        vErr: ''
                    },
                    weight: {
                        w: '',
                        wErr: ''
                    },
                    pickUpInfo: {
                        pickup: false,
                        zip: '',
                        err: false
                    },
                    toDoorInfo: {
                        toDoor: false,
                        zip: '',
                        err: false
                    },
                    portClearance: true
                },
                seaLcl: {
                    originPort: {
                        port: '',
                        portErr: false
                    },
                    destPort: {
                        port: '',
                        portErr: false
                    },
                    volume: {
                        v: '',
                        vErr: ''
                    },
                    weight: {
                        w: '',
                        wErr: ''
                    },
                    keywords: {
                        pickupInfo: {
                            isPickupSupport: false,
                            err: false
                        },
                        doorInfo: {
                            isDoorSupport: false,
                            zip: '',
                            countryErr: false,
                            zipErr: false
                        }
                    }
                  
                },
                seaFcl: {
                    originPort: {
                        port: '',
                        portErr: false
                    },
                    destPort: {
                        port: '',
                        portErr: false
                    },
                    GP20: 1,
                    GP40: 0,
                    HQ40: 0,
                    keywords: {
                        isCustom: false,
                        insuranceInfo: {
                            isInsurance: false,
                            invoice: '',
                            invoiceCurrency: 'usd'
                        },
                        truckingInfo: {
                            isTrucking: false,
                            toDoorDistrict: '',
                            province: '',
                            city: '',
                            district: '',
                            town: ''
                        }
                    }
                },
                eche: {
                    originPort: {
                        port: '',
                        portErr: false
                    },
                    destPort: {
                        port: '',
                        portErr: false
                    },
                },
                landTrailer: {
                    originPort: {
                        port: '',
                        portErr: false
                    },
                    destPort: {
                        port: '',
                        portErr: false
                    },
                },
                landRail: {
                    destPort: {
                        port: '',
                        portErr: false
                    },
                    destStorage: {
                        show: false,
                    },
                    originPort: {
                        show: false
                    }
                }
            },
            queryResult: [
                {
                    title: '门到门',
                    subTitle: '免报关费',
                    list: [],
                    search: false
                },
                {
                    title: '仓到门',
                    list: [],
                    search: false
                }
            ],
            queryLoading: false,
            clickedList: {
            }
        };

        vm.f = {
            toggleTransportWay: toggleTransportWay,
            showTabNav: showTabNav,
            hideTabNav: hideTabNav,
            updateCurWay: updateCurWay,
            selectExpressDest: selectExpressDest,
            toggleGoodsDialog: toggleGoodsDialog,
            addGoods: addGoods,
            delGoods: delGoods,
            clearGoods: clearGoods,
            checkGoodsAttr: checkGoodsAttr,
            countGoodsInfo: countGoodsInfo,
            queryExpressFare: queryExpressFare,
            selectAirOriginPort: selectAirOriginPort,
            selectAirDestCity: selectAirDestCity,
            setAddrTabActive: setAddrTabActive,
            checkAirVW: checkAirVW,
            queryAirFare: queryAirFare,
            openDropDownMenu: openDropDownMenu,
            selectSeaLclOriginPort: selectSeaLclOriginPort,
            selectSeaLclDestPort: selectSeaLclDestPort,
            querySealclFare: querySealclFare,
            selectSeaFclOriginPort: selectSeaFclOriginPort,
            selectSeaFclDestPort: selectSeaFclDestPort,
            minus1: minus1,
            add1: add1,
            querySeafclFare: querySeafclFare,
            queryEcheFare: queryEcheFare,
            queryTrailerFare: queryTrailerFare,
            queryLandRailFare: queryLandRailFare,
            showFareDetail: showFareDetail,
            selectRailDestStore: selectRailDestStore,
            selectOriginPort: selectOriginPort,
            changeRailOriginPortShow: changeRailOriginPortShow,
            changeRailDestStorageShow: changeRailDestStorageShow,
            querySeaFlcFareByExtra: querySeaFlcFareByExtra,
            selectPort: selectPort,
            selectSeaLclDoorAddr: selectSeaLclDoorAddr,
            checkSeaLclDoorZip: checkSeaLclDoorZip,
            filterList: filterList,
            clearSelectCompleteInfo: clearSelectCompleteInfo
        };

        init();

        function init() {
            console.log('[LogisticsQueryCtrl] init: ');
            toggleTransportWay(2); // 默认是快递的方式
            initEvent();
        }

        // 切换物流服务类型
        function toggleTransportWay(index) {
            var transportWay = vm.c.transportWay;
            for (var i = 0; i < transportWay.length; i++) {
                transportWay[i].active = false;
            }
            transportWay[index].active = true;

            if (index === 2) {
                vm.d.queryResult = store.expressQuery;
            } else {
                vm.d.queryResult = store.normalQuery;
            }

            if (index === 1 || index === 2) {
                updateCurWay(transportWay[index]);
            }
        }

        // 更新当前的运输方式
        function updateCurWay(way) {
            vm.c.curWay = {
                name: way.name,
                en: way.en,
                source: way.source,
                serviceType: way.serviceType
            };
            hideTabNav();

            if (way.type === 'sea') {
                toggleTransportWay(0);
                vm.c.transportWay[0].name = way.name;
            }

            if (way.type === 'eche') {
                toggleTransportWay(3);
                vm.c.transportWay[3].name = way.name;
            }
        }

        // 打开海运、陆运列表
        function showTabNav(way) {
            vm.c.curTabNavType = way.en;
            console.log('vm.c.curTabNavType', way.en);
        }

        // 隐藏海运、陆运列表
        function hideTabNav() {
            vm.c.curTabNavType = '';
        }

        /**********************快递运输方式相关操作*************************/

        // 选择快递目的地 dest: destination
        function selectExpressDest(dest) {
            vm.c.expressDest.selected = angular.copy(dest);
            closeDropDownMenu('expressDest');
            vm.d.queryWayInfo.express.destination.destErr = false;
        }

        /**
         * 打开/关闭 货件信息弹框
         * @param option {string} open || close
         */
        function toggleGoodsDialog(option) {
            var showDialog = vm.d.queryWayInfo.express.goodsInfo.showDialog;
            vm.d.queryWayInfo.express.goodsInfo.showDialog = option ? option === 'open' : !showDialog;
            closeDropDownMenu('expressDest');
        }

        // 设置包裹信息初始值
        function getBasicGoodsInfo() {
            return {
                leng: '',
                width: '',
                height: '',
                weight: '',
                quantity: '',
                err: {
                    leng: false,
                    width: false,
                    height: false,
                    weight: false,
                    quantity: false,
                }
            };
        }

        // 校验包裹信息是否填写完整
        function checkGoodsFull() {
            var goodsList = vm.d.queryWayInfo.express.goodsInfo.goods;
            var lastGoods = goodsList[goodsList.length - 1];
            var hasEmptyInfo = !lastGoods.leng || !lastGoods.width || !lastGoods.height || !lastGoods.weight || !lastGoods.quantity;
            var emptyInfoAttr = [];

            for (var attr in lastGoods) {
                if (lastGoods.hasOwnProperty(attr)) {
                    lastGoods.err[attr] = false;
                    !lastGoods[attr] && emptyInfoAttr.push(attr);
                }
            }

            if (hasEmptyInfo) {
                emptyInfoAttr.forEach(function (item) {
                    lastGoods.err[item] = true;
                })
                return false;
            }

            return true;
        }

        // 添加包裹
        function addGoods() {

            var goodsList = vm.d.queryWayInfo.express.goodsInfo.goods;

            if (!checkGoodsFull()) {
                return;
            }

            var goods = getBasicGoodsInfo();
            goodsList.push(goods);
        }

        // 删除包裹
        function delGoods(index) {
            vm.d.queryWayInfo.express.goodsInfo.goods.splice(index, 1);
        }

        // 清空包裹
        function clearGoods() {
            var basicGoodsInfo = getBasicGoodsInfo();
            vm.d.queryWayInfo.express.goodsInfo.goods = [basicGoodsInfo];
        }

        // 计算包裹总信息
        function countGoodsInfo() {

            if (!checkGoodsFull()) {
                return;
            }

            var goodsInfo = vm.d.queryWayInfo.express.goodsInfo;
            var goodsList = goodsInfo.goods;

            var list = goodsList.map(function (goods) {
                return {
                    weight: +goods.weight * goods.quantity,
                    volume: +goods.leng * goods.width * goods.height
                }
            });

            var detail = {
                weight: 0,
                volume: 0
            };
            list.forEach(function (item) {
                detail.weight += item.weight;
                detail.volume += item.volume;
            })

            goodsInfo.detail = detail;
            goodsInfo.total = detail.volume + 'cm³，' + detail.weight + 'kg';
            toggleGoodsDialog('close');
            vm.d.queryWayInfo.express.goodsInfo.goodsInfoErr = false;
        }

        // 加载目的地列表
        function loadExpressDestList() {

            if (vm.c.expressDest.list.length) {
                vm.c.expressDest.curList = vm.c.expressDest.list;
                return;
            }

            var params = {
                serviceType: 'express',
                source: 'ma',
                json: {
                    "field": "destinationCountry"
                }
            }

            loadPort(params, 'expressDest', 'destinationCountry')
                .then(function (list) {
                    vm.c.expressDest.list = list;
                    vm.c.expressDest.curList = list;
                });
        }

        // 校验查询条件
        function checkQuertCond() {

            initError();

            // 校验zip
            var reg = /^[0-9]{6}$/;
            var zip = vm.d.queryWayInfo.express.originZip.zip;
            if (!reg.test(zip)) {
                vm.d.queryWayInfo.express.originZip.zipErr = true;
                return false;
            }

            // 校验包裹信息
            if (!checkGoodsFull() || !vm.d.queryWayInfo.express.goodsInfo.total) {
                vm.d.queryWayInfo.express.goodsInfo.goodsInfoErr = true;
                toggleGoodsDialog('open');
                return false;
            }

            // 校验目的国
            if (!vm.c.expressDest.selected.value) {
                vm.d.queryWayInfo.express.destination.destErr = true;
                return false;
            }

            return true;

            function initError() {
                vm.d.queryWayInfo.express.originZip.zipErr = false;
                vm.d.queryWayInfo.express.goodsInfo.goodsInfoErr = false;
                vm.d.queryWayInfo.express.destination.destErr = false;
            }
        }

        // 查询快递物流的运价
        function queryExpressFare() {

            vm.c.expressDest.selected.value = getAddrValue(vm.c.expressDest.list, vm.c.expressDest.selected.label);

            if (!checkQuertCond()) {
                return;
            }

            var params = {
                cond: {
                    conditions: {
                        airPackageList: getPackageList(), // 包裹信息
                        destinationCountry: vm.c.expressDest.selected.value, // 目的国简称
                        originZip: vm.d.queryWayInfo.express.originZip.zip, // 邮编
                        serviceType: 'express'
                    },
                    pagination: {
                        pageDisplay: false,
                        pageNumber: 1,
                        pageSize: 50
                    },
                    sort: {}
                }
            };

            beginQuery();

            request.get('/pub/api/expressSolution', params, false)
                .then(callback, errCallback)
                .then(handleQueryResult)
                .finally(function () {
                    vm.d.queryLoading = false;
                });

            function callback(res) {
                return util.safe(res, 'data.solutionList', {});
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'logistics-query.js',
                    funcName: 'queryExpressFare',
                    text: '查询快递运价失败'
                });
                return {};
            }

            function handleQueryResult(result) {
                var list = [];

                for (var attr in result) {
                    var resultItem = result[attr];
                    var queryItem = {};
                    queryItem.title = attr;
                    queryItem.search = true;
                    queryItem.list = []

                    for (var subAttr in resultItem) {
                        var subItem = resultItem[subAttr];
                        var l = subItem.map(function (sub) {
                            return {
                                title: sub.deliverTo,
                                serviceName: sub.serviceName,
                                cutoff: sub.cutoff,
                                transportTime: sub.transportTime,
                                estimatedCostTxt: sub.estimatedCostTxt
                            };
                        })
                        queryItem.list = queryItem.list.concat(l);
                    }

                    list.push(queryItem);
                }
                vm.d.queryResult = list;
            }

            function beginQuery() {
                vm.d.queryLoading = true;
                vm.d.queryResult = vm.d.queryResult.map(function (item) {
                    return {
                        title: item.title,
                        subTitle: item.subTitle,
                        list: [],
                        search: true
                    }
                })
            }

            function getPackageList() {
                var goods = vm.d.queryWayInfo.express.goodsInfo.goods;
                return goods.map(function (item) {
                    return {
                        leng: item.leng,
                        height: item.height,
                        weight: item.weight,
                        width: item.width,
                        quantity: item.quantity
                    }
                });
            }

        }

        // 包裹信息校验
        function checkGoodsAttr(index, attr, num) {
            var data = vm.d.queryWayInfo.express.goodsInfo.goods[index][attr];
            var result = onlyNumber(+data);

            if (!result) {
                vm.d.queryWayInfo.express.goodsInfo.goods[index][attr] = '';
                return;
            }

            var i = data.indexOf('.');
            if (!data.slice(i + 1)[1]) {
                return;
            }

            var m;
            if (num === 2) {
                m = 100;
            }

            if (num === 3) {
                m = 1000;
            }

            vm.d.queryWayInfo.express.goodsInfo.goods[index][attr] = Math.round(data * m) / m;
        }

        /****************************空运相关操作**********************************/

        // 选择空运的始发港
        function selectAirOriginPort(port) {
            vm.c.airOriginPort.selected = angular.copy(port);
            closeDropDownMenu('airOriginPort');
            vm.d.queryWayInfo.air.originPort.portErr = false;
        }

        // 加载始发港列表
        function loadAirOriginPortList() {

            if (vm.c.airOriginPort.list.length) {
                vm.c.airOriginPort.curList = vm.c.airOriginPort.list;
                return;
            }

            var params = {
                serviceType: 'air_ptp',
                source: 'onePartner',
                json: {field: 'originCity'}
            };

            loadPort(params, 'airOriginPort', 'originCity')
                .then(function (list) {
                    vm.c.airOriginPort.list = list;
                    vm.c.airOriginPort.curList = list;
                });
        }

        // 加载目的港列表
        function loadAirDestPort() {
            if (vm.c.airDestPort.list.length) {
                return;
            }

            var params = {
                serviceType: 'air_ptp',
                source: 'onePartner',
                json: {field: 'destinationCity'}
            };

            loadPort(params, 'airDestPort', 'destinationCity')
                .then(function (list) {
                    vm.c.airDestPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.airDestPort.tabs[0].id = list[0].value;
                });
        }

        // 选择目的港城市
        function selectAirDestCity(item) {
            vm.c.airDestPort.city.selected = item;
            closeDropDownMenu('airDestPort');
        }

        // 查询空运物流的运价
        function queryAirFare() {

            vm.c.airOriginPort.selected.value = getAddrValue(vm.c.airOriginPort.list, vm.c.airOriginPort.selected.label);

            if (!checkODVWQuertCond('airOriginPort', 'airDestPort', 'air')) {
                return;
            }

            if(!checkOtherInfo()) {
                return;
            }

            var basicInfo = {
                originCity: vm.c.airOriginPort.selected.value, // 始发港value
                destinationCity: vm.c.airDestPort.completeInfo.value,
                volume: +vm.d.queryWayInfo.air.volume.v,
                weight: +vm.d.queryWayInfo.air.weight.w
            };

            var airInfo = vm.d.queryWayInfo.air;
            var otherInfo = {};

            if (airInfo.pickUpInfo.pickup) { // 上门提货 originZip: 邮编
                otherInfo.pickup = true;
                otherInfo.originZip = airInfo.pickUpInfo.zip;
            } else {
                otherInfo.pickup = false;
            }

            if (airInfo.toDoorInfo.toDoor) { // 送货上门 destinationAddress： 邮编
                otherInfo.toDoor = true;
                otherInfo.destinationAddress = airInfo.toDoorInfo.zip;
            } else {
                otherInfo.toDoor = false;
            }

            otherInfo.portClearance = airInfo.portClearance; // 目的港清关

            var params = {
                serviceType: 'air_ptp',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: angular.extend({}, basicInfo, otherInfo)
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                result.forEach(function (item) {
                    aitResultItem.serviceModeName = item.serviceModeName || '';
                    var list = item.children || [];
                    aitResultItem.list = list.map(function (d) {
                        var costData = d.costData || {};

                        return {
                            serviceName: d.serviceName || '',
                            deliver: d.deliver || '',
                            transportTime: d.transportTime || '',
                            cost: d.cost || '',
                            cutoff: d.cutoff || '',
                            schedule: d.schedule || '',
                            destAirPort: d.destAirPort || '',
                            showDetail: false,
                            localCost: decodeHtmlFn(costData.localCost || {}), // 本地费用
                            additionalCost: decodeHtmlFn(costData.additionalCost || {}), // 附加费用
                            transportCost: decodeHtmlFn(costData.transportCost || {}), // 运费
                            otherCost: decodeHtmlFn(costData.otherCost || {}), // 其他费用
                        }
                    });
                    airResultList = airResultList.concat(aitResultItem);
                });

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }

            function checkOtherInfo() {
                var airInfo = vm.d.queryWayInfo.air;
                var reg = /^[0-9]{6}$/;

                initErr();

                if (airInfo.pickUpInfo.pickup) {
                    if (!airInfo.pickUpInfo.zip || !reg.test(airInfo.pickUpInfo.zip)) {
                        vm.d.queryWayInfo.air.pickUpInfo.err = true;
                        return false;
                    }
                }

                if (airInfo.toDoorInfo.toDoor) {
                    if (!airInfo.toDoorInfo.zip || !reg.test(airInfo.toDoorInfo.zip)) {
                        vm.d.queryWayInfo.air.toDoorInfo.err = true;
                        return false;
                    }
                }

                return true;

                function initErr() {
                    vm.d.queryWayInfo.air.pickUpInfo.err = false;
                    vm.d.queryWayInfo.air.toDoorInfo.err = false;
                }
            }

            function decodeHtmlFn(data) {
                var list = data.feeItemList || [];
                data.feeItemList = list.map(function (d) {
                    return {
                        expression: util.decodeHtml(d.expression || ''),
                        currency: d.currency || '',
                        name: d.name || '',
                        total: d.total || ''
                    }
                });
                return data;
            }

        }

        /***************************海运拼箱相关操作***************************************/

        // 加载海运拼箱始发港
        function loadSeaLclOriginPort() {
            if (vm.c.seaLclOriginPort.list.length) {
                vm.c.seaLclOriginPort.curList = vm.c.seaLclOriginPort.list;
                return;
            }

            var params = {
                serviceType: 'lcl',
                source: 'onePartner',
                json: {field: 'originPort'}
            };

            loadPort(params, 'seaLclOriginPort', 'originPort')
                .then(function (list) {
                    vm.c.seaLclOriginPort.list = list;
                    vm.c.seaLclOriginPort.curList = list;
                });
        }

        // 选择海运拼箱的始发港
        function selectSeaLclOriginPort(port) {
            vm.c.seaLclOriginPort.selected = angular.copy(port);
            closeDropDownMenu('seaLclOriginPort');
            vm.d.queryWayInfo.seaLcl.originPort.portErr = false;
        }

        // 选择目的港
        function selectSeaLclDestPort(port) {
            vm.c.seaLclDestPort.selected = angular.copy(port);
            closeDropDownMenu('seaLclDestPort');
            vm.d.queryWayInfo.seaLcl.destPort.portErr = false;
        }

        function loadSeaLlcPickUpAddr() {
            if (vm.c.seaLclPickUpAddr.list.length) {
                return;
            }

            var params = {
                serviceType: 'lcl',
                source: 'onePartner',
                json: {field: 'locationData'}
            };

            loadPort(params, 'seaLclPickUpAddr', 'locationData')
                .then(function (list) {
                    vm.c.seaLclPickUpAddr.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.seaLclPickUpAddr.tabs[0].id = list[0].value;
                });
        }

        function loadSeaLlcDoorAddr() {
            if (vm.c.seaLclDoorAddr.list.length) {
                vm.c.seaLclDoorAddr.curList = vm.c.seaLclDoorAddr.list;
                return;
            }

            var params = {
                serviceType: 'lcl',
                source: 'onePartner',
                json: {field: 'destinationCountry'}
            };

            loadPort(params, 'seaLclDoorAddr', 'destinationCountry')
                .then(function (list) {
                    vm.c.seaLclDoorAddr.list = list;
                    vm.c.seaLclDoorAddr.curList = list;
                });
        }

        function selectSeaLclDoorAddr(item) {
            vm.c.seaLclDoorAddr.selected = angular.copy(item);
            vm.d.queryWayInfo.seaLcl.keywords.doorInfo.countryErr = false;
            closeDropDownMenu('seaLclDoorAddr');
        }

        // 查询海运拼箱物流的运价
        function querySealclFare() {

            vm.c.seaLclOriginPort.selected.value = getAddrValue(vm.c.seaLclOriginPort.list, vm.c.seaLclOriginPort.selected.label);
            vm.c.seaLclDoorAddr.selected.value = getAddrValue(vm.c.seaLclDoorAddr.list, vm.c.seaLclDoorAddr.selected.label);

            if (!checkODVWQuertCond('seaLclOriginPort', 'seaLclDestPort', 'seaLcl')) {
                return;
            }

            if (!checkOhterParams()) {
                return;
            }

            var keywords = handleOtherParams();

            var params = {
                serviceType: 'lcl',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: {
                        originPort: vm.c.seaLclOriginPort.selected.value, // 始发港value
                        destinationPort: vm.c.seaLclDestPort.selected.value,
                        volume: +vm.d.queryWayInfo.seaLcl.volume.v,
                        weight: +vm.d.queryWayInfo.seaLcl.weight.w
                    },
                    keywords: keywords,
                    sort: {}
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                aitResultItem.list = result.map(function (d) {
                    var cost = d.cost || {};
                    return {
                        serviceProvider: d.serviceProvider || '',
                        serviceProviderCode: d.serviceProviderCode || '',
                        quoteEndDate: d.quoteEndDate || '',
                        etdWeek: d.etdWeek || '',
                        transportTime: '预计' + d.transportTime || '',
                        totalCost: cost.totalCost || {},
                        showDetail: false,
                        loadPortCost: cost.loadPortCost || {},
                        shippingCost: cost.shippingCost || {},
                        destinationCost: cost.destinationCost || {},
                        exchangeRates: cost.exchangeRates || [],
                        estimateCost: cost.estimateCost || [],
                        warehouseInfo: d.warehouseInfo || {}
                    }
                });
                airResultList = airResultList.concat(aitResultItem);

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }

            function handleOtherParams() {
                var keywords = {
                    pickUpDistrict: '',
                    isPickupSupport: false,
                    isDoorSupport: false,
                    province: '',
                    city: '',
                    district: '',
                    town: '',
                    doorCityCode: '',
                    doorCountryCode: '',
                    doorPostalCode: ''
                };

                if (vm.d.queryWayInfo.seaLcl.keywords.pickupInfo.isPickupSupport) {
                    keywords.isPickupSupport = true;
                    keywords.pickUpDistrict = vm.c.seaLclPickUpAddr.completeInfo.value;
                }

                if (vm.d.queryWayInfo.seaLcl.keywords.doorInfo.isDoorSupport) {
                    keywords.isDoorSupport = true;
                    keywords.doorPostalCode = vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zip;
                    keywords.doorCountryCode = vm.c.seaLclDoorAddr.selected.value;
                }

                return keywords;
            }

            function checkOhterParams() {
                initErr();

                var isPickupSupport = vm.d.queryWayInfo.seaLcl.keywords.pickupInfo.isPickupSupport;
                var isDoorSupport = vm.d.queryWayInfo.seaLcl.keywords.doorInfo.isDoorSupport;


                if (isPickupSupport && !vm.c.seaLclPickUpAddr.completeInfo.value) {
                    vm.d.queryWayInfo.seaLcl.keywords.pickupInfo.err = true;
                    return false;
                }

                if (isDoorSupport && !vm.c.seaLclDoorAddr.selected.value) {
                    vm.d.queryWayInfo.seaLcl.keywords.doorInfo.countryErr = true;
                    return false;
                }

                if (isDoorSupport && !vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zip) {
                    vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zipErr = true;
                    return false;
                }

                return true;

                function initErr() {
                    vm.d.queryWayInfo.seaLcl.keywords.pickupInfo.err = false;
                    vm.d.queryWayInfo.seaLcl.keywords.doorInfo.countryErr = false;
                    vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zipErr = false;
                }
            }

        }

        function checkSeaLclDoorZip() {
            var reg = /^[0-9]{6}$/;
            var zip = vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zip;
            if (!reg.test(zip)) {
                vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zipErr = true;
                return;
            }
            vm.d.queryWayInfo.seaLcl.keywords.doorInfo.zipErr = false;
        }

        /*********************海运整柜****************************/

        // 加载海运整柜始发港
        function loadSeaFclOriginPort() {
            if (vm.c.seaFlcOriginPort.list.length) {
                vm.c.seaFlcOriginPort.curList = vm.c.seaFlcOriginPort.list;
                return;
            }

            var params = {
                serviceType: 'eshipping',
                source: 'onePartner',
                json: {field: 'originPort'}
            };

            loadPort(params, 'seaFlcOriginPort', 'originPort')
                .then(function (list) {
                    vm.c.seaFlcOriginPort.list = list;
                    vm.c.seaFlcOriginPort.curList = list;
                });
        }

        // 选择海运整柜的始发港
        function selectSeaFclOriginPort(port) {
            vm.c.seaFlcOriginPort.selected = angular.copy(port);
            closeDropDownMenu('seaFlcOriginPort');
            vm.d.queryWayInfo.seaFcl.originPort.portErr = false;
        }

        // 选择海运整柜的目的港
        function selectSeaFclDestPort(port) {
            vm.c.seaFlcDestPort.selected = angular.copy(port);
            closeDropDownMenu('seaFlcDestPort');
            vm.d.queryWayInfo.seaFcl.destPort.portErr = false;
        }

        // -1
        function minus1(attr) {
            var num = vm.d.queryWayInfo.seaFcl[attr];

            if (num <= 0) {
                return;
            }

            vm.d.queryWayInfo.seaFcl[attr]--;
        }

        // +1
        function add1(attr) {
            var num = vm.d.queryWayInfo.seaFcl[attr];

            if (num >= 10) {
                return;
            }

            vm.d.queryWayInfo.seaFcl[attr]++;
        }

        // 选中货运保险
        function querySeaFlcFareByExtra() {
            var extraParams = {
                isCustom: vm.d.queryWayInfo.seaFcl.keywords.isCustom,
                inInsurance: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.isInsurance,
                invoice: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.invoice || '',
                invoiceCurrency: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.invoiceCurrency || '',
                isTrucking: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.isTrucking,
                toDoorDistrict: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.toDoorDistrict || '',
                province: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.province || '',
                city: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.city || '',
                district: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.district || '',
                town: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.town || '',
            };

            querySeafclFare(extraParams);
        }

        // 查询海运整柜物流的运价
        function querySeafclFare(extraParams) {

            vm.c.seaFlcOriginPort.selected.value = getAddrValue(vm.c.seaFlcOriginPort.list, vm.c.seaFlcOriginPort.selected.label);

            if (!checkOriginAndDest('seaFlcOriginPort', 'seaFcl', 'seaFlcDestPort')) {
                return;
            }

            extraParams = extraParams || {
                isCustom: false,
                toDoorDistrict: '',
                isTrucking: false,
                isInsurance: false
            };

            var params = {
                serviceType: 'eshipping',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: {
                        originPort: vm.c.seaFlcOriginPort.selected.value, // 始发港value
                        destinationPort: vm.c.seaFlcDestPort.selected.value,
                        c20gp: +vm.d.queryWayInfo.seaFcl.GP20,
                        c40gp: +vm.d.queryWayInfo.seaFcl.GP40,
                        c40hq: +vm.d.queryWayInfo.seaFcl.HQ40
                    },
                    keywords: angular.extend({}, {}, extraParams),
                    sort: {
                        key: 'totalCost',
                        type: 1
                    }
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                aitResultItem.list = result.map(function (d) {
                    var cost = d.cost || {};
                    return {
                        serviceProvider: d.serviceProvider || '',
                        serviceProviderCode: d.serviceProviderCode || '',
                        shippingCompany: d.shippingCompany || '',
                        loadDock: d.loadDock || '',
                        shippingDate: d.shippingDate || '',
                        etdWeekDayView: d.etdWeekDayView || '',
                        transportTime: '预计' + d.transportTime || '',
                        dischargeOrDirect: d.dischargeOrDirect || '',
                        loadLocalCost: decodeHtmlForSea(cost.loadLocalCost || {}), // {currency: 'CNY', total: '1.00'}
                        shippingCost: decodeHtmlForSea(cost.shippingCost || {}),
                        totalCost: decodeHtmlForSea(cost.totalCost || {}),
                        exchangeRates: decodeHtmlForSea(cost.exchangeRates || {}),
                        billOfLading: d.billOfLading || '',
                        showDetail: false
                    }
                });
                airResultList = airResultList.concat(aitResultItem);

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }

            function decodeHtmlForSea(data) {
                var list = data.feeItemList || [];
                data.feeItemList = list.map(function (d) {
                    return {
                        expression: util.decodeHtml(d.expression || ''),
                        currency: d.currency || '',
                        name: d.name || '',
                        total: d.total || ''
                    }
                });
                return data;
            }

        }

        /************************中港陆运******************************/
        // 加载中港陆运始发地
        function loadEcheOriginPort() {
            if (vm.c.echeOriginPort.list.length) {
                return;
            }

            var params = {
                serviceType: 'eche',
                source: 'onePartner',
                json: {field: 'fromArea'}
            };

            loadPort(params, 'echeOriginPort', 'fromArea')
                .then(function (list) {
                    vm.c.echeOriginPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.echeOriginPort.tabs[0].id = list[0].value;
                });
        }

        // 加载中港陆运目的地
        function loadEcheDestPort() {
            if (vm.c.echeDestPort.list.length) {
                return;
            }

            var params = {
                serviceType: 'eche',
                source: 'onePartner',
                json: {field: 'toArea'}
            };

            loadPort(params, 'echeDestPort', 'toArea')
                .then(function (list) {
                    vm.c.echeDestPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.echeDestPort.tabs[0].id = list[0].value;
                });
        }

        // 查询中港陆运物流的运价
        function queryEcheFare() {

            if (!checkOriginAndDest('echeOriginPort', 'eche', 'echeDestPort')) {
                return;
            }

            var params = {
                serviceType: 'eche',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: {
                        fromArea: vm.c.echeOriginPort.completeInfo.value, // 始发港value
                        toArea: vm.c.echeDestPort.completeInfo.value,
                    },
                    sort: {}
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                aitResultItem.list = result.map(function (d) {

                    var otherDesc = d.otherDesc || {};
                    var costDesc = d.costDesc || {};

                    return {
                        serviceTypeName: d.serviceTypeName || '',
                        timeliness: d.timeliness || '',
                        clearance: d.clearance || {},
                        carTypeList: d.carTypeList || [],
                        costList: d.costList || [],
                        costListDesc: d.costListDesc || [],
                        attentionListTitle: otherDesc.title || '',
                        attentionVal: decodeHtml(otherDesc.data || []),
                        costDescTitle: costDesc.title || '',
                        costDescVal: decodeHtml(costDesc.data || []),
                    }
                });
                airResultList = airResultList.concat(aitResultItem);

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }

        }

        function loadSeaFlcDestAddr() {

            if (vm.c.seaFlcDestAddr.list.length) {
                return;
            }

            var params = {
                serviceType: 'eshipping',
                source: 'onePartner',
                json: {
                    field: 'threeLevelAdministrativeArea'
                }
            };

            loadPort(params, 'seaFlcDestAddr', 'threeLevelAdministrativeArea')
                .then(function (result) {
                    vm.c.seaFlcDestAddr.list = result;
                    vm.d.clickedList[result[0].value] = result;
                    vm.c.seaFlcDestAddr.tabs[0].id = result[0].value;
                })
        }

        /**********************集港拖车****************************/

        // 加载集港拖车始发地
        function loadTrailerOriginPort() {

            if (vm.c.landTrailerOriginPort.list.length) {
                return;
            }

            var params = {
                serviceType: 'land_trailer',
                source: 'onePartner',
                json: {field: 'toArea'}
            };

            loadPort(params, 'landTrailerOriginPort', 'toArea')
                .then(function (list) {
                    vm.c.landTrailerOriginPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.landTrailerOriginPort.tabs[0].id = list[0].value;
                });
        }

        // 加载集港拖车目的地
        function loadTrailerDestPort(originPortId) {

            var originPortList = originPortId.split(',');
            var toArea = originPortList[originPortList.length - 1];
            var params = {
                serviceType: 'land_trailer',
                source: 'onePartner',
                json: {
                    field: 'fromArea',
                    toArea: toArea
                }
            };

            vm.c.landTrailerDestPort.list = [];
            vm.c.landTrailerDestPort.tabs = [
                {name: '请选择', active: true}
            ];
            return loadPort(params, 'landTrailerDestPort', 'fromArea')
                .then(function (list) {
                    oldOriginPortId = originPortId;
                    vm.c.landTrailerDestPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.landTrailerDestPort.tabs[0].id = list[0].value;
                });
        }

        // 查询集港拖车运价
        function queryTrailerFare() {

            if (!checkOriginAndDest('landTrailerOriginPort', 'landTrailer', 'landTrailerDestPort')) {
                return;
            }

            var params = {
                serviceType: 'land_trailer',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: {
                        toArea: vm.c.landTrailerOriginPort.completeInfo.value, // 始发港value
                        fromArea: vm.c.landTrailerDestPort.completeInfo.value,
                    },
                    sort: {}
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                aitResultItem.list = result.map(function (d) {
                    return {
                        serviceProviderName: d.serviceProviderName || '',
                        containerTypeList: d.saleQuote.containerTypeList || [],
                        trackingFeeList: d.saleQuote.trackingFeeList || []
                    }
                });
                airResultList = airResultList.concat(aitResultItem);

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }
        }

        /*************************国际铁路********************************/
        // 加载国际铁路目的地
        function loadLandRailDestPort() {
            if (vm.c.landRailDestPort.list.length) {
                return;
            }

            var params = {
                serviceType: 'land_rail',
                source: 'onePartner',
                json: {field: 'destinationCity'}
            };

            loadPort(params, 'landRailDestPort', 'destinationCity')
                .then(function (list) {
                    vm.c.landRailDestPort.list = list;
                    vm.d.clickedList[list[0].value] = list;
                    vm.c.landRailDestPort.tabs[0].id = list[0].value;
                });
        }

        // 加载目的站点
        function loadLandRailDestStore() {
            var params = {
                serviceType: 'land_rail',
                source: 'onePartner',
                json: {
                    field: 'destinationPort',
                    destinationCity: vm.c.landRailDestPort.completeInfo.value
                }
            };

            loadPort(params, 'landRailDestStore', 'destinationPort')
                .then(function(result) {
                    vm.c.landRailDestStore.list = result;
                })
        }

        // 选择目的站点
        function selectRailDestStore(item) {
            vm.c.landRailDestStore.selected = item;
            closeDropDownMenu('landRailDestStore');
            queryLandRailFare();
        }

        // 加载始发站点
        function loadLandRailOriginPort() {
            var params = {
                serviceType: 'land_rail',
                source: 'onePartner',
                json: {
                    field: 'originPort',
                    destinationCity: vm.c.landRailDestPort.completeInfo.value
                }
            };

            loadPort(params, 'landRailOriginPort', 'originPort')
                .then(function(result) {
                    vm.c.landRailOriginPort.list = result;
                })
        }

        // 选择始发站点
        function selectOriginPort(item) {
            vm.c.landRailOriginPort.selected = item;
            closeDropDownMenu('landRailOriginPort');
            queryLandRailFare();
        }

        function changeRailDestStorageShow() {
            !vm.d.queryWayInfo.landRail.destStorage.show && (vm.c.landRailDestStore.selected = {});
        }

        function changeRailOriginPortShow() {
            !vm.d.queryWayInfo.landRail.originPort.show && (vm.c.landRailOriginPort.selected = {});
        }

        // 查询国际铁路运价
        function queryLandRailFare() {

            if (!checkDest()) {
                return;
            }

            var extraParams = {
                hasDestinationPort: true,
                destinationPort: vm.c.landRailDestStore.selected.value || '',
                hasOriginPort: true,
                originPort: vm.c.landRailOriginPort.selected.value || ''
            };

            var params = {
                serviceType: 'land_rail',
                source: 'ma',
                json: {
                    pagination: {
                        pageDisplay: false,
                        pageSize: 1,
                        pageNumber: 50
                    },
                    conditions: angular.extend({}, {destinationCity: vm.c.landRailDestPort.completeInfo.value}, extraParams),
                    sort: {}
                }
            };

            queryFare(params)
                .then(handleQueryResult);

            function handleQueryResult(result) {

                var airResultList = [];
                var aitResultItem = {};
                aitResultItem.search = true;
                aitResultItem.list = result.map(function (d) {
                    return {
                        serviceTypeName: d.serviceTypeName || '',
                        originPortName: d.originPortName || '',
                        destinationPortName: d.destinationPortName || '',
                        shiftsName: d.shiftsName[0],
                        transDays: d.transDays,
                        validStart: d.validStart,
                        validEnd: d.validEnd,
                        trackingFeeList: d.saleQuote.trackingFeeList[0],
                        attentionListTitle: d.attentionList.title || '',
                        attentionVal: decodeHtml(d.attentionList.data || []),
                        otherFeeVal: decodeHtml(d.otherFeeList.data || []),
                        otherFeeTitle: d.otherFeeList.title || '',
                        showDetail: false
                    }
                });
                airResultList = airResultList.concat(aitResultItem);

                if (!airResultList.length) {
                    airResultList.push({
                        list: [],
                        search: true
                    });
                }
                vm.d.queryResult = airResultList;
            }

            function checkDest() {
                initErr();

                // 校验目的港
                if (!vm.c.landRailDestPort.completeInfo.label) {
                    vm.d.queryWayInfo.landRail.destPort.portErr = true;
                    return false;
                }

                return true;

                function initErr() {
                    vm.d.queryWayInfo.landRail.destPort.portErr = false;
                }
            }
        }

        /**************************通用事件****************************/

        function onlyNumber(data) {
            var reg = /^\d+(\.\d{1,4})?$/;
            if (!reg.test(data)) {
                return false;
            }
            return true;
        }

        function openDropDownMenu(e, type) {

            e.stopPropagation()

            var tabIndex;

            if (Array.isArray(vm.c[type].tabs)) {
                tabIndex = vm.c[type].tabs.length - 1;
            }

            switch (type) {
                case 'expressDest':
                    vm.d.queryWayInfo.express.goodsInfo.showDialog = false;
                    loadExpressDestList();
                    break;
                case 'airOriginPort':
                    closeDropDownMenu('airDestPort');
                    loadAirOriginPortList();
                    break;
                case 'airDestPort':
                    closeDropDownMenu('airOriginPort');
                    setAddrTabActive('airDestPort', tabIndex);
                    loadAirDestPort();
                    break;
                case 'seaLclOriginPort':
                    closeDropDownMenu('seaLclDestPort');
                    closeDropDownMenu('seaLclPickUpAddr');
                    closeDropDownMenu('seaLclDoorAddr');
                    loadSeaLclOriginPort();
                    break;
                case 'seaLclDestPort':
                    closeDropDownMenu('seaLclOriginPort');
                    closeDropDownMenu('seaLclPickUpAddr');
                    closeDropDownMenu('seaLclDoorAddr');
                    break;
                case 'seaFlcOriginPort':
                    closeDropDownMenu('seaFlcDestPort');
                    closeDropDownMenu('seaFlcDestAddr');
                    loadSeaFclOriginPort();
                    break;
                case 'seaFlcDestPort':
                    closeDropDownMenu('seaFlcOriginPort');
                    closeDropDownMenu('seaFlcDestAddr');
                    break;
                case 'echeOriginPort':
                    closeDropDownMenu('echeDestPort');
                    setAddrTabActive('echeOriginPort', tabIndex);
                    loadEcheOriginPort();
                    break;
                case 'echeDestPort':
                    closeDropDownMenu('echeOriginPort');
                    setAddrTabActive('echeDestPort', tabIndex);
                    loadEcheDestPort();
                    break;
                case 'landTrailerOriginPort':
                    closeDropDownMenu('landTrailerDestPort');
                    setAddrTabActive('landTrailerOriginPort', tabIndex);
                    loadTrailerOriginPort();
                    break;
                case 'landTrailerDestPort':
                    closeDropDownMenu('landTrailerOriginPort');
                    var provinceId = vm.c.landTrailerOriginPort.completeInfo.value;
                    if (!provinceId) {
                        return;
                    }

                    if (oldOriginPortId === provinceId) {
                        setAddrTabActive('landTrailerDestPort', tabIndex);
                        break;
                    }

                    loadTrailerDestPort(provinceId)
                        .then(function () {
                            setAddrTabActive('landTrailerDestPort', 0);
                        });
                    break;
                case 'landRailDestPort':
                    closeDropDownMenu('landRailDestStore');
                    closeDropDownMenu('landRailOriginPort');
                    setAddrTabActive('landRailDestPort', tabIndex);
                    loadLandRailDestPort();
                    break;
                case 'landRailDestStore':
                    closeDropDownMenu('landRailDestPort');
                    closeDropDownMenu('landRailOriginPort');
                    if (!vm.c.landRailDestPort.completeInfo.value) {
                        return;
                    }
                    loadLandRailDestStore();
                    break;
                case 'landRailOriginPort':
                    closeDropDownMenu('landRailDestPort');
                    closeDropDownMenu('landRailDestStore');
                    if (!vm.c.landRailDestPort.completeInfo.value) {
                        return;
                    }
                    loadLandRailOriginPort();
                    break;
                case 'seaFlcDestAddr':
                    closeDropDownMenu('seaFlcOriginPort');
                    closeDropDownMenu('seaFlcDestPort');
                    setAddrTabActive('seaFlcDestAddr', tabIndex);
                    loadSeaFlcDestAddr();
                    break;
                case 'seaLclPickUpAddr':
                    closeDropDownMenu('seaLclDestPort');
                    closeDropDownMenu('seaLclOriginPort');
                    closeDropDownMenu('seaLclDoorAddr');
                    setAddrTabActive('seaLclPickUpAddr', tabIndex);
                    loadSeaLlcPickUpAddr();
                    break;
                case 'seaLclDoorAddr':
                    closeDropDownMenu('seaLclDestPort');
                    closeDropDownMenu('seaLclOriginPort');
                    closeDropDownMenu('seaLclPickUpAddr');
                    loadSeaLlcDoorAddr();
                    break;
            }

            vm.c[type].show = true;
        }

        function closeDropDownMenu(type) {
            vm.c[type].show = false;
        }

        // 校验体积和重量
        function checkAirVW(type, subAttr, num) {
            var data = vm.d.queryWayInfo[type][subAttr].v;
            var result = onlyNumber(+data);

            if (!result) {
                vm.d.queryWayInfo[type][subAttr].v = '';
                return;
            }

            var i = data.indexOf('.');
            if (!data.slice(i + 1)[1]) {
                return;
            }

            var m;
            if (num === 2) {
                m = 100;
            }

            if (num === 3) {
                m = 1000;
            }

            vm.d.queryWayInfo[type][subAttr].v = Math.round(data * m) / m;
        }

        // 检查 空运/海运拼箱 的查询条件是否正确 //(airOriginPort air)
        function checkODVWQuertCond(cAttrO, cAttrD, dAttr) {
            initError();

            var originPort = Array.isArray(vm.c[cAttrO].selected) ? vm.c[cAttrO].completeInfo : vm.c[cAttrO].selected;
            var destPort = Array.isArray(vm.c[cAttrD].selected) ? vm.c[cAttrD].completeInfo : vm.c[cAttrD].selected;

            // 校验始发港
            if (!originPort.value) {
                vm.d.queryWayInfo[dAttr].originPort.portErr = true;
                return false;
            }

            // 校验目的港
            if (!destPort.value) {
                vm.d.queryWayInfo[dAttr].destPort.portErr = true;
                return false;
            }

            // 校验体积
            if (!vm.d.queryWayInfo[dAttr].volume.v) {
                vm.d.queryWayInfo[dAttr].volume.vErr = true;
                return false;
            }

            if (!vm.d.queryWayInfo[dAttr].weight.w) {
                vm.d.queryWayInfo[dAttr].weight.wErr = true;
                return false;
            }

            return true;

            function initError() {
                vm.d.queryWayInfo[dAttr].originPort.portErr = false;
                vm.d.queryWayInfo[dAttr].destPort.portErr = false;
                vm.d.queryWayInfo[dAttr].volume.vErr = false;
                vm.d.queryWayInfo[dAttr].weight.wErr = false;
            }
        }

        // 只检查 始发港和目的港
        function checkOriginAndDest(cType1, dType, cType2) {
            initErr();

            var originPort = Array.isArray(vm.c[cType1].selected) ? vm.c[cType1].completeInfo : vm.c[cType1].selected;
            var destPort = Array.isArray(vm.c[cType2].selected) ? vm.c[cType2].completeInfo : vm.c[cType2].selected;

            // 校验始发港
            if (!originPort.value) {
                vm.d.queryWayInfo[dType].originPort.portErr = true;
                return false;
            }

            // 校验目的港
            if (!destPort.value) {
                vm.d.queryWayInfo[dType].destPort.portErr = true;
                return false;
            }

            return true;

            function initErr() {
                vm.d.queryWayInfo[dType].originPort.portErr = false;
                vm.d.queryWayInfo[dType].destPort.portErr = false;
            }
        }

        /**
         * 为含有2级菜单的地址设置tab的激活状态
         * 设置空运目的港:airDestPort  中港陆运始发港:echeOriginPort tab的激活状态
         * @param attr
         * @param index
         */
        function setAddrTabActive(attr, index) {
            var tabs = vm.c[attr].tabs;
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].active = false;
            }
            tabs[index].active = true;

            var id = tabs[index].id;

            if (id && vm.d.clickedList[id] && vm.d.clickedList[id].length > 0) {
                vm.c[attr].list = vm.d.clickedList[id];
            }

        }

        /**
         * 为含有多级菜单的地址选择地址
         * 选择空运目的港、中港陆运的始发地城市 ...
         * @param type
         * @param tabTile
         * @param item
         */
        function selectPort(type, tabTile, item) {

            // 当显示多级tab时，点击前面的tab， 要清除该tab后面的tab
            handleSelectedAndTabs();

            // push点击的item
            if (vm.c[type].selected.indexOf(item) === -1) {
                vm.c[type].selected.push(item);
            }

            var curSelectedLength = vm.c[type].selected.length;
            var tabs = vm.c[type].tabs;

            // push tab 赋值下一级的list 并激活最后一级的tab
            if (item.children && item.children.length) {
                var tab = {
                    name: tabTile,
                    id: item.children[0].value
                };
                tabs.push(tab);
                vm.c[type].list = item.children;
                vm.d.clickedList[tab.id] = item.children;
                activeTabAndSetName();
                return;
            }

            // 海运整柜的拖车服务 点击第3级item 动态获取第四级item
            if (type === 'seaFlcDestAddr' && curSelectedLength === 3) {
                loadTowns(item).then(function (result) {
                    var tab = {
                        name: '请选择',
                        id: result[0].value
                    };
                    tabs.push(tab);
                    vm.c.seaFlcDestAddr.list = result;
                    vm.d.clickedList[result[0].value] = result;
                    activeTabAndSetName();
                });
                return;
            }

            // 选择完成
            handleSelectCompleteInfo(type);

            if (type === 'landTrailerOriginPort') {
                if (oldOriginPortId !== vm.c.landTrailerOriginPort.completeInfo.value) {
                    vm.c.landTrailerDestPort.completeInfo = {
                        label: '',
                        value: ''
                    }
                }
            }

            function loadTowns(curItem) {
                var params = {
                    distinct: curItem.value
                };
                return request.get('/pub/api/queryTowns', params, false)
                    .then(function (res) {
                        return (res.data || []).map(function (d) {
                            return {
                                label: d.name,
                                value: d.id
                            };
                        })
                    })
            }

            function handleSelectCompleteInfo(arg_type) {
                var list = vm.c[type].selected;
                var completeInfo = {
                    label: '',
                    value: ''
                };
                list.forEach(function (ele) {
                    completeInfo.label += ele.label + ' ';
                    completeInfo.value += ele.value + ',';
                });

                var index = completeInfo.value.lastIndexOf(',');
                completeInfo.value = completeInfo.value.slice(0, index);
                vm.c[type].completeInfo = completeInfo;
                closeDropDownMenu(arg_type);

                if (arg_type === 'seaFlcDestAddr') {

                    var extraParams = {
                        isCustom: vm.d.queryWayInfo.seaFcl.keywords.isCustom,
                        inInsurance: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.isInsurance,
                        invoice: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.invoice || '',
                        invoiceCurrency: vm.d.queryWayInfo.seaFcl.keywords.insuranceInfo.invoiceCurrency || '',
                        isTrucking: vm.d.queryWayInfo.seaFcl.keywords.truckingInfo.isTrucking,
                        toDoorDistrict: completeInfo.value
                    };

                    querySeafclFare(extraParams);
                }

                if (arg_type === 'seaLclPickUpAddr') {
                    vm.d.queryWayInfo.seaLcl.keywords.pickupInfo.err = false;
                    querySealclFare();
                }

                hideErrorTip(arg_type);
            }

            function handleSelectedAndTabs() {
                var curActiveTab = findActiveTabIndex();
                vm.c[type].selected = vm.c[type].selected.slice(0, curActiveTab);
                vm.c[type].tabs = vm.c[type].tabs.slice(0, curActiveTab + 1);
            }

            function findActiveTabIndex() {
                var tabs = vm.c[type].tabs;
                var index;
                tabs.forEach(function(e, i) {
                    e.active && (index = i);
                })
                return index;
            }

            function activeTabAndSetName() {
                tabs[tabs.length - 2].name = item.label;
                setAddrTabActive(type, tabs.length -1);
            }
        }

        function hideErrorTip(type) {
            var queryWayInfo = vm.d.queryWayInfo;
            switch (type) {
                case 'echeOriginPort':
                    queryWayInfo.eche.originPort.portErr = false;
                    break;
                case 'echeDestPort':
                    queryWayInfo.eche.destPort.portErr = false;
                    break;
                case 'landTrailerOriginPort':
                    queryWayInfo.landTrailer.originPort.portErr = false;
                    break;
                case 'landTrailerDestPort':
                    queryWayInfo.landTrailer.destPort.portErr = false;
                    break;
                case 'landRailDestPort':
                    queryWayInfo.landRail.destPort.portErr = false;
                    break;
                case 'airDestPort':
                    queryWayInfo.air.destPort.portErr = false;
                    break;
            }
        }

        /***
         * 加载列表
         * @param params
         * @param cType
         * @param filed
         * @returns {*}
         */
        function loadPort(params, cType, filed) {

            vm.c[cType].loading = true;

            return request.get('/pub/api/getCondition', params, false)
                .then(callback, errCallback)
                .then(handleData)
                .finally(function () {
                    vm.c[cType].loading = false;
                })

            function callback(res) {
                return util.safe(res, 'data.' + filed, []);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'logistics-query.js',
                    funcName: 'loadEcheOriginPort',
                    text: '加载下拉列表失败'
                });
                return [];
            }

            function handleData(destList) {
                var list = destList.map(function (dest) {

                    var children = (dest.children || []).map(function (child) {

                        var children2 = (child.children || []).map(function (child2) {

                            var children3 = (child2.children || []).map(function (child3) {

                                var children4 = (child3.children || []).map(function (child4) {
                                    return {
                                        label: child4.name || '',
                                        value: child4.id || '',
                                        children: []
                                    }
                                });

                                return {
                                    label: child3.name || '',
                                    value: child3.id || '',
                                    children: children4
                                }
                            });

                            return {
                                label: child2.name || '',
                                value: child2.id || '',
                                children: children3
                            }
                        });

                        return {
                            label: child.name || '',
                            value: child.id || '',
                            children: children2
                        }
                    })

                    return {
                        label: dest.name || '',
                        value: dest.id || '',
                        children: children
                    };
                });

                return list;
            }

        }

        // 查询运价
        function queryFare(params) {

            beginQuery();

            return request.get('/pub/api/querySolution', params, false)
                .then(callback, errCallback)
                .finally(function () {
                    vm.d.queryLoading = false;
                });

            function callback(res) {
                return util.safe(res, 'data.solutionList', []);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'logistics-query.js',
                    funcName: 'queryFare',
                    text: '查询运价失败'
                });
                return [];
            }

            function beginQuery() {
                vm.d.queryLoading = true;
                vm.d.queryResult = [
                    {
                        list: [],
                        search: true
                    }
                ]
            }
        }

        var oldListItem = {};
        // 显示/关闭 详情
        function showFareDetail(item) {
            item.showDetail = !item.showDetail;

            if (oldListItem !== item) {
                oldListItem.showDetail = false;
                oldListItem = item;
            }
        }

        function decodeHtml(data) {
            return data.map(function (item) {
                return {
                    val: util.decodeHtml(item.val || '')
                }
            });
        }

        function initEvent() {
            $(document).on('click', function () {
                store.listKey.forEach(function(item) {
                    $timeout(function () {
                        closeDropDownMenu(item);
                    })
                });

                vm.d.queryWayInfo.express.goodsInfo.showDialog = false;
            });

            $('.super-selector-popup-linkage').on('click', function(e) {
                e.stopPropagation();
            })
            $('.goods-info-wrap').on('click', function(e) {
                e.stopPropagation();
            })
        }

        function filterList(targetLabel, list, targetListField) {
            var curList = [];
            list.forEach(function (item) {
                if (item.label.toLowerCase().indexOf(targetLabel.toLowerCase()) !== -1) {
                    curList.push({
                        label: item.label,
                        value: item.value,
                        children: item.children
                    });
                }
            });

            vm.c[targetListField].curList = curList.length < 1 ? list : curList;

        }

        function getAddrValue(list, label) {
            var value = '';

            if (!label) {
                return '';
            }

            for (var i = 0; i < list.length; i++) {
                if (list[i].label.toLowerCase() === label.toLowerCase()) {
                    value = list[i].value;
                    break;
                }
            }

            return value;
        }

        function clearSelectCompleteInfo(type) {
            vm.c[type].completeInfo = {
                label: '',
                value: ''
            };
        }
        
        
    }

})();
